module.exports = __webpack_public_path__ + "static/img/new_control.f496808.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new_control.png
// module id = D14B
// module chunks = 1